import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { SchoolsPageRoutingModule } from './schools-routing.module';
import { SchoolsPageComponent } from './schools.page';

@NgModule({
  declarations: [SchoolsPageComponent],
  imports: [
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CdkVirtualScrollViewport,
    CommonModule,
    FormsModule,
    GoogleMap,
    IonicModule,
    MapInfoWindow,
    MapMarker,
    MiscModule,
    SchoolsPageRoutingModule
  ]
})
export class SchoolsPageModule {}
